export function pick<T extends object, U extends keyof T>(obj: T, paths: U[]): Pick<T, U> {
	const ret = Object.create(null);
	for (const k of paths) {
		if (obj[k] !== undefined) ret[k] = obj[k];
	}
	return ret;
}
